import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import React, { useState } from "react";
import { ChromePicker } from "react-color";
import { fixedColors } from "./data";

interface ColorPlateProps {
  trigger: React.ReactNode;
  color: string;
  updateColor: (val) => void;
  colorPlateAlign?:"start"|"center"|"end";
}

const ColorPlate: React.FC<ColorPlateProps> = ({
  trigger,
  color,
  updateColor,
  colorPlateAlign="start"
}) => {
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>{trigger}</PopoverTrigger>
        <PopoverContent
          align={colorPlateAlign}
          alignOffset={50}
          className={`bg-none border-none border-[#E9ECF2] cursor-pointer w-[max-content] !p-0`}
        >
          <ChromePicker
            onChange={(newColor) => {
              updateColor(newColor.hex);
            }}
            color={color}
            presetColors={fixedColors}
          />
        </PopoverContent>
      </Popover>
    </React.Fragment>
  );
};

export default ColorPlate;
